import React from 'react';
import logoBlack from '../../../assets/logo-noir.png';

import CONFIG from '../../../config';
import WidgetInputText from '../../../components/widgets/WidgetInputText';

import axios from "axios";
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import { useNavigate } from 'react-router-dom';


function RenvoyerMail() {
  const navigate = useNavigate();

  React.useEffect(() => {
    axios.get(CONFIG.API_URL + '/api/me', { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
      .then((response) => {
        switch (response.status) {
          case 200:
            navigate("/client/dossier");
            break;

          default:
            break;
        }
      })
      .catch((e) => {

      });
  }, []);

  const [done, setDone] = React.useState(false);
  const [email, setEmail] = React.useState(null);
  const [sendVerifyEmailValid, setSendVerifyEmailValid] = React.useState(false);
  const formSendVerifyEmail = [[email, setEmail]];


  React.useEffect(() => {
    setSendVerifyEmailValid(false);

    if (email === null || email.value === '')
      return;

    setSendVerifyEmailValid(true);
  }, formSendVerifyEmail.map((x) => x[0]));


  const submitFormSendVerifyEmail = () => {
    let payload = {};

    if (email !== null) {
      payload['email'] = email.value;
    }

    axios.post(CONFIG.API_URL + '/api/send_verify_email', payload)
      .then((response) => {

      })
      .catch((e) => {

      });

    setDone(true);
  };


  return (
    <>
      <div className='m-6 grid grid-cols-12 gap-x-4 shrink-0 p-6 max-w-lg mx-auto bg-white my-shadow'>
        <div className='col-start-3 col-span-8 w-full item-center mb-6'>
          <img src={logoBlack} alt="Logo" />
        </div>

        <div className='col-span-12 w-full mb-2 text-center'>
          <h1>Renvoyer un mail de vérification</h1>
        </div>

        <div className='col-start-2 col-span-10 w-full mb-6 text-center'>
          Renseignez l'adresse email associée à votre compte.
        </div>

        <div className='col-start-2 col-span-10 w-full mb-4'>
          <WidgetInputText state={email} setState={setEmail} id={'email'} text={"Email"} regex={"^.+@.+$"} regex_helper={"Adresse email non-valide"} />
        </div>

        {done &&
          <div className='col-start-2 col-span-10 w-full mb-4 text-center text-sm bg-green-200 rounded-md p-2'>
            Si un compte est associé à cette adresse email, vous avez dû recevoir un nouveau mail de vérification. <br></br><br></br>Pensez à vérifier vos spams.
          </div>
        }

        <div className='col-start-2 col-span-5 w-full text-left'>
          <Link className='text-xs' color='inherit' href={CONFIG.BASE_URL + "/connexion"}>Se connecter ?</Link>
        </div>

        <div className='col-start-7 col-span-5 w-full text-right'>
          <Button variant='contained' disabled={!sendVerifyEmailValid} onClick={submitFormSendVerifyEmail}>
            Envoyer
          </Button>
        </div>
      </div>
    </>
  );
}

export default RenvoyerMail;